import { useState } from "react";
import { ConsultantuseAuth } from "../../../security/ConsultantUseAuth";
import { APISendConsultantPortalFeedback } from "./api/APISendConsultantPortalFeedback";

function ContactUs({ screenWidth }) {
  const { logoutConsultant } = ConsultantuseAuth();

  const [FeedbackText, setFeedbackText] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    APISendConsultantPortalFeedback(
      FeedbackText,
      localStorage.getItem("Consultant_id"),
      logoutConsultant
    );
    setFeedbackText("");
  };

  return (
    <div class="w3-container w3-padding-64  w3-theme-l4" id="contact">
      <div
        class="w3-row"
        style={{
          display: screenWidth === "Small" ? "flex" : "",
          flexDirection: screenWidth === "Small" ? "column" : "",
          flexWrap: screenWidth === "Small" ? "wrap" : "",
        }}
      >
        <div
          class="w3-col m4"
          style={{
            textAlign: screenWidth === "Small" ? "center" : "",
            width: screenWidth === "Small" ? "100%" : "",
          }}
        >
          <div class="w3-padding-16">
            <span class="w3-xlarge w3-border-teal w3-bottombar">
              Contact Us
            </span>
          </div>
          <h3>Address</h3>
          <p>
            <i class="fa fa-map-marker w3-text-teal w3-xlarge"></i> Dukes House
          </p>
          <p>58 Buckingham Gate</p>
          <p>London SW1E 6AJ</p>
          <p>
            <i class="fa fa-phone w3-text-teal w3-xlarge"></i> +44 (0) 203 488
            5089
          </p>
          <p>
            <i class="fa fa-envelope-o w3-text-teal w3-xlarge"></i>{" "}
            international@investin.org
          </p>
        </div>
        <div
          class="w3-col m8"
          style={{
            textAlign: screenWidth === "Small" ? "center" : "",
            width: screenWidth === "Small" ? "100%" : "",
          }}
        >
          <form
            class="w3-container w3-card-4 w3-padding-16 w3-white"
            target="_blank"
            onSubmit={handleSubmit}
          >
            <div class="w3-section">
              <label>Report a Bug / Request a new Feature to the system</label>
              <br></br>
              <br></br>
              <textarea
                class="w3-input"
                name="Message"
                id="FeedbackText"
                value={FeedbackText}
                onChange={(e) => setFeedbackText(e.target.value)}
                required
                style={{ height: "200px", border: "1px solid #ccc" }}
              ></textarea>
            </div>
            <button type="submit" class="w3-button w3-right w3-theme">
              Send
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
